import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Heading, useColorModeValue } from "@chakra-ui/react";
/** This component is used to display when there is no data present */
export const NoData = (props) => {
    const { text = "No Results Found" } = props;
    const borderColor = useColorModeValue("gray.100", "gray.700");
    return (_jsx(Box, { minH: "150px", display: "flex", alignItems: "center", justifyContent: "center", borderColor: borderColor, borderWidth: "1px", children: _jsx(Heading, { fontSize: "32px", fontWeight: 700, className: "card-text", children: text }) }));
};
//# sourceMappingURL=noData.js.map